import { motion } from "framer-motion";

const ALBUM_COVER = "https://customer-assets.emergentagent.com/job_preludium-experience/artifacts/dqu2xvrj_Preludium%20album%20ok%C5%82adka.jpg";

export default function HeroSection() {
  const scrollToPreorder = () => {
    const el = document.querySelector("#preorder");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden hero-bg grain-bg scanline"
    >
      {/* Gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black z-[2]" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/40 z-[2]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20 pt-20 pb-10">
          {/* Text content */}
          <motion.div
            className="flex-1 text-center lg:text-left order-2 lg:order-1"
            initial={{ opacity: 0, x: -60 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <motion.p
              className="text-[#A0B0C4] font-['Manrope'] text-sm md:text-base tracking-[0.3em] uppercase mb-4"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              Nowy album
            </motion.p>

            <h1
              className="font-['Oswald'] text-6xl sm:text-7xl lg:text-8xl xl:text-9xl font-bold uppercase tracking-tighter leading-[0.85] mb-2 glitch-text"
              data-text="PUEBLO"
              data-testid="hero-artist-name"
            >
              PUEBLO
            </h1>

            <h2
              className="font-['Oswald'] text-3xl sm:text-4xl lg:text-5xl font-light uppercase tracking-[0.15em] text-[#A0B0C4] mb-8"
              data-testid="hero-album-title"
            >
              Preludium
            </h2>

            <motion.p
              className="text-[#A0B0C4] font-['Manrope'] text-base md:text-lg max-w-md mb-10 mx-auto lg:mx-0"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              Limitowany ponumerowany album. Wstęp do większego dzieła
            </motion.p>

            <motion.button
              data-testid="hero-cta-button"
              onClick={scrollToPreorder}
              className="bg-[#EB0023] text-white font-['Oswald'] text-lg uppercase tracking-wider px-10 py-4 hover:bg-white hover:text-black transition-all duration-300 cta-pulse"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              Kup preorder
            </motion.button>
          </motion.div>

          {/* Album cover */}
          <motion.div
            className="flex-shrink-0 order-1 lg:order-2"
            initial={{ opacity: 0, y: 40, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <div className="album-float relative group">
              <div className="absolute -inset-1 bg-gradient-to-br from-[#EB0023]/20 to-[#32558B]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <img
                src={ALBUM_COVER}
                alt="Preludium - Album Cover"
                data-testid="hero-album-cover"
                className="w-[280px] sm:w-[340px] lg:w-[420px] xl:w-[480px] shadow-2xl shadow-black/60"
                loading="eager"
              />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
      >
        <div className="w-[1px] h-12 bg-gradient-to-b from-[#A0B0C4] to-transparent" />
      </motion.div>
    </section>
  );
}
